import { render } from "./SeparateAnswer.vue?vue&type=template&id=d915371e&scoped=true"
import script from "./SeparateAnswer.vue?vue&type=script&lang=js"
export * from "./SeparateAnswer.vue?vue&type=script&lang=js"

import "./SeparateAnswer.vue?vue&type=style&index=0&id=d915371e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d915371e"]])

export default __exports__